export default function initDialog() {
  Alpine.data('dialog', (formHandle: '') => ({
    dialogOpen: false,
    formRefreshed: false,
    formHandle,
    scrollPosition: window.scrollY || window.pageYOffset,

    toggle() {
      this.dialogOpen = !this.dialogOpen;

      if (this.dialogOpen) {
        this.scrollPosition = window.scrollY || window.pageYOffset;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';

        if (!this.formRefreshed) {
          const form = this.$refs.dialog.querySelector('form');
          if (form) {
            const csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
            if (csrfInput) {
              fetch(`/actions/formie/forms/refresh-tokens/?form=${this.formHandle}`)
                .then((res) => res.json())
                .then((result) => {
                  csrfInput.outerHTML = result.csrf.input;

                  if (result.captchas && result.captchas.javascript) {
                    const jsCaptcha = result.captchas.javascript;

                    const jsCaptchaInput = form.querySelector(`input[name="${jsCaptcha.sessionKey}"]`) as HTMLInputElement;
                    if (jsCaptchaInput) {
                      jsCaptchaInput.value = jsCaptcha.value;
                    }
                  }

                  if (result.captchas && result.captchas.duplicate) {
                    const duplicateCaptcha = result.captchas.duplicate;

                    const duplicateCaptchaInput = form.querySelector(`input[name="${duplicateCaptcha.sessionKey}"]`) as HTMLInputElement;
                    if (duplicateCaptchaInput) {
                      duplicateCaptchaInput.value = duplicateCaptcha.value;
                    }
                  }

                  if (form.form && form.form.formTheme) {
                    form.form.formTheme.updateFormHash();
                  }

                  this.formRefreshed = true;
                });
            }
          }
        }
      } else {
        document.body.style.removeProperty('overflow');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';

        window.scroll({ left: 0, top: this.scrollPosition, behavior: 'instant' }); // Restore page position
      }
    },
  }));
}
